import { api } from "@/api/api";

export const Faq = {
    state: {
        faqList: [],
    },
    getters: {
        getFaqList(state) {
            return state.faqList;
        },
    },
    mutations: {
        setFaqList(state, payload) {
            state.faqList = payload;
        },
    },
    actions: {
        async getFaqList({ commit }) {
            await api.faq
                .getFaqList()
                .then((res) => {
                    commit("setFaqList", res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async getFaq(_, id) {
            const response = await api.faq.getFaq(id).catch((err) => {
                console.log(err);
                return Promise.reject(err.response.data.message);
            });
            return Promise.resolve(response.data);
        },

        async addFaq({ dispatch }, args) {
            await api.faq
                .addFaq(args)
                .then(() => {
                    dispatch("getFaqList");
                })
                .catch((err) => {
                    console.log(err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve();
        },

        async updateFaq({ dispatch }, args) {
            await api.faq
                .updateFaq(args)
                .then(() => {
                    dispatch("getFaqList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async deleteFaq({ dispatch }, args) {
            await api.faq
                .deleteFaq(args)
                .then(() => {
                    dispatch("getFaqList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },
    },
};
